<template>
  <div class="privacy-policy">
    <h1>“大有阳光”软件隐私保护政策</h1>
    <p class="update-date">更新日期：{{ updateDate }}</p>
    <p class="effective-date">生效日期：{{ effectiveDate }}</p>

    <h2>引言</h2>
    <p>
      广州大有网络科技有限公司（以下简称“我们”）作为“大有阳光”软件（以下简称“本软件”）的运营者，严格遵守《中华人民共和国个人信息保护法》《中华人民共和国网络安全法》《儿童个人信息网络保护规定》等相关法律法规，致力于保护用户的个人信息安全与隐私权益。本《“大有阳光”软件隐私保护政策》（以下简称“本政策”）旨在向您清晰说明我们如何收集、使用、存储、共享、保护及处理您的个人信息，并保障您对个人信息的控制权。<b>未满十四周岁的儿童及十四至十八岁的未成年人</b>须在监护人陪同下阅读并取得其同意后使用本软件。
    </p>
    <p>
      请您在使用本软件前仔细阅读并理解本政策全部内容。如您为未成年人（尤其未满十四周岁），须在监护人陪同下阅读并取得其同意后使用本软件。若您不同意本隐私政策内容，请立即停止使用本软件；继续使用即视为您已充分理解并同意本隐私政策的全部条款，但涉及敏感个人信息处理、重大权益变更等核心条款应以单独明示同意为准。
    </p>

    <h2>一、个人信息定义与范围</h2>
    <p>
      本政策所指“个人信息”是以电子或其他方式记录的与已识别或可识别的自然人有关的各种信息，不包括匿名化处理后的信息。为避免歧义，去标识化处理后的信息仍属于个人信息。
    </p>
    <p>
      敏感个人信息：包括生物识别、特定身份、医疗健康、行踪轨迹等信息，一旦泄露可能导致人身、财产安全受损。我们将以加粗、标红等方式特别提示敏感信息的处理规则。对于敏感个人信息，我们将严格遵循必要性原则，仅在实现产品或服务功能所必需的范围内进行处理，并采取更严格的安全保护措施。
    </p>

    <h2>二、我们如何收集和使用您的个人信息</h2>
    <h3>（一）收集信息的目的与合法性基础</h3>
    <p>
      我们仅出于以下目的，在最小必要范围内收集您的个人信息，并以“用户授权同意”“履行合同”“法律义务”或“公共利益”（公共利益的适用需符合法律明确规定或经主管机关审核）为合法性基础：
    </p>
    <ul>
      <li>
        1.账号注册与登录
        <p>
          手机号码、验证码、登录密码（用于身份核验与账号安全）；
        </p>
        <p>
          第三方登录：通过微信、QQ等第三方平台登录时，绑定手机号完成注册；法律依据：履行与您的服务合同。
        </p>
      </li>
      <li>
        2.核心功能服务
        <p>
          趣味测评/专业测评/房树人测评：通过题目作答或者是绘画方式测评，用于生成个性化报告；
        </p>
        <p>心理状态描述等敏感信息的处理将依据加密、脱敏等技术手段确保安全；</p>
        <p>
          普测任务作答：支持家长绑定孩子账号完成教育局或学校普测任务的作答；
        </p>
        <p>
          轻干预大模型（“聊聊”）：基于语音输入、文字对话内容，提供陪伴聊天、心理干预建议；
        </p>
        <p>心理课程与直播：提供专业的心理课程以及心理直播内容。</p>
      </li>
      <li>
        3.设备权限与数据

        <p>
          相机/相册：上传头像、测评图片（如房树人测评）；
        </p>
        <p>麦克风：语音咨询或轻干预大模型（“聊聊”）的语音交互；</p>
        <p>存储权限：保存测评结果至本地；</p>
        <p>
          设备信息：设备型号、操作系统、IP地址、唯一设备标识符（IMEI/Android
          ID/IDFA），用于安全风控与统计分析；
        </p>
        <p>
          本软件不会持续收集位置信息，相关权限仅在用户主动开启时生效。法律依据：根据功能需要逐项征得授权，用户可随时通过设备设置关闭权限。当您选择关闭某项权限时，我们将提供替代方案以确保核心功能的正常使用。例如，关闭麦克风权限后，您仍可通过手动输入文字使用轻干预大模型；
        </p>
        <p>关闭相机权限后，您可以通过上传本地图片完成相关测评。</p>
      </li>
      <li>
        4.其他场景
        <p>
          客服与争议处理：保存通话录音、聊天记录，用于解决纠纷；
        </p>
        <p>改进服务：通过去标识化数据优化算法、分析用户行为；</p>
        <p>
          去标识化数据处理将符合国家标准或行业最佳实践，确保数据安全。法律合规：依法配合司法机关、监管部门的调取要求。
        </p>
      </li>
    </ul>

    <h3>（二）个人信息使用的限制</h3>
    <p>
      我们承诺：
    </p>
    <ul>
      <li>不超范围收集或使用个人信息；</li>
      <li>变更使用目的时重新征得同意；</li>
      <li>敏感信息处理前单独告知并获得明示授权；</li>
      <li>采取必要措施保护个人信息安全，防止信息泄露、篡改、丢失；</li>
      <li>发生或可能发生个人信息泄露时及时采取补救措施并按规定告知用户。</li>
    </ul>

    <h2>三、我们如何共享、转让与公开披露个人信息</h2>
    <p>1. 共享</p>
    <p>
      第三方服务商：为提供功能支持，接入以下SDK：
    </p>
    <p>
      新增或变更第三方SDK时，我们将通过版本更新日志、弹窗公告等显著方式提前7日告知用户。
    </p>
    <table>
      <thead>
        <tr>
          <th>SDK名称</th>
          <th>功能</th>
          <th>收集信息类型</th>
          <th>隐私政策</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>微信SDK</td>
          <td>登录/分享</td>
          <td>设备标识符、昵称</td>
          <td>微信隐私保护政策</td>
        </tr>
        <tr>
          <td>QQ互联SDK</td>
          <td>登录/分享</td>
          <td>设备标识符、昵称</td>
          <td>QQ互联SDK隐私保护声明</td>
        </tr>
        <tr>
          <td>友盟SDK</td>
          <td>三方登录/社会化分享/统计分析</td>
          <td>Android ID、设备信息、网络日志且已要求友盟SDK进行去标识化处理</td>
          <td>友盟平台政策隐私协议</td>
        </tr>
        <tr>
          <td>极光推送 SDK </td>
          <td>消息推送</td>
          <td>OAID、Android ID、MAC 地址、应用安装列表、SSID、BSSID、IP 信息</td>
          <td>极光推送隐私政策</td>
        </tr>
      </tbody>
    </table>
    <p>
      第三方SDK的隐私政策可能独立于本政策，建议您在使用前仔细阅读。若第三方违反数据安全承诺，我们将立即终止合作并采取法律手段追责。
    </p>

    <p>2. 转让</p>
    <p>
      我们不会将您的用户信息转让给任何公司、组织和个人，但以下情况除外：
    </p>
    <ul>
      <li>
        （1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的用户信息。
      </li>
      <li>
        （2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必需的情况进行提供。
      </li>
      <li>
        （3）符合与您签署的相关协议（包括在线签署的电子协议）或其他的法律文件约定所提供。
      </li>
    </ul>

    <p>3. 公开披露</p>
    <p>
      我们仅会在以下情况下，才会公开披露您的用户信息：
    </p>
    <ul>
      <li>
        （1）获得您明确同意或基于您的主动选择，我们可能会公开披露您的用户信息。
      </li>
      <li>
        （2）根据法律法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的用户信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。
      </li>
    </ul>

    <p>4. 共享、转让、公开披露用户信息时事先征得授权同意的例外</p>
    <p>
      以下情形中，共享、转让、公开披露您的用户信息无需事先征得您的授权同意：
    </p>
    <ul>
      <li>（1）与国家安全、国防安全有关的。</li>
      <li>（2）与公共安全、公共卫生、重大公共利益有关的。</li>
      <li>（3）与刑事侦查、起诉、审判和判决执行等有关的。</li>
      <li>
        （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的。
      </li>
      <li>（5）您自行向社会公众公开的个人信息。</li>
      <li>
        （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
      </li>
      <li>
        （7）为履行我们的法定职责或者法定义务或响应政府主管部门指示所必需的。
      </li>
    </ul>

    <h2>四、我们如何储存您的个人信息</h2>
    <p>
      本软件仅面向中国大陆地区（仅为本政策之目的，不包含香港特别行政区、澳门特别行政区和中国台湾地区）提供。原则上，我们在中华人民共和国境内收集产生的个人信息，存储在中华人民共和国境内，不会进行跨境传输。
    </p>

    <p>1. 存储地点</p>
    <p>
      本公司遵守法律法规，收集的有关您的信息和资料将保存在中华人民共和国境内大陆地区的“大有阳光”软件服务器上。以下情形除外：
    </p>
    <ul>
      <li>（1）法律法规有明确规定；</li>
      <li>（2）获得您的明确授权。</li>
    </ul>

    <p>2. 存储期限</p>
    <p>
      一般而言，我们将在您使用本软件期间为实现本政策所述目的所必需的最短时间保留您的个人信息，除非可适用的法律法规或国家规范性文件另有规定。具体参考法律包括：
    </p>
    <ul>
      <li>
        （1）《中华人民共和国网络安全法》第三章第二十一条规定：采取监测、记录网络运行状态、网络安全事件的技术措施，并按照规定留存相关的网络日志不少于六个月。
      </li>
      <li>
        （2）《中华人民共和国电子商务法》第二章第三十一条规定：商品和服务信息、交易信息保存时间自交易完成之日起不少于三年；法律、行政法规另有规定的，依照其规定。在超过上述期限，或您主动要求删除您的个人信息或注销您的账号后，我们将根据适用法律法规的要求尽快删除您的个人信息，除非可适用的法律法规或国家规范性文件要求在更长的期间内保留这些信息。但在下列情况下，因需符合法律要求，更改个人信息的存储时间：

        <ol>
          <li>1）为遵守适用的法律法规等有关规定；</li>
          <li>2）为遵守法院判决、裁定或其他法律程序的规定；</li>
          <li>3）为遵守相关政府机关或法定授权组织的要求；</li>
          <li>
            4）北京师范大学出版集团大有阳光心理平台有理由确信需要遵守法律法规等有关规定；
          </li>
          <li>
            5）为执行相关服务协议或本政策、维护社会公共利益，为保护北京师范大学出版集团大有阳光心理平台的客户、北京师范大学出版集团大有阳光心理平台、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。
          </li>
        </ol>
      </li>
    </ul>

    <p>3. 安全措施</p>
    <p>
      （1）在信息传输层进行SSL加密传输，保障敏感数据传输的不可解密性；
    </p>
    <p>
      （2）进行数据脱敏（测评报告中的敏感字段（如姓名、联系方式）将替换为不可逆哈希值，确保无法通过技术手段还原）；
    </p>
    <p>
      （3）定期进行数据的巡查，审查数据收集、存储及处理流程是否合规；
    </p>
    <p>
      （4）严格限制内部人员对敏感数据的访问权限，实行最小必要的权限原则；
    </p>
    <p>
      （5）定期执行安全审计工作；
    </p>
    <p>
      （6）管理措施：与员工签订保密协议并定期对员工进行数据安全与隐私保护培训与考核；
    </p>
    <p>
      （7）建立数据的应急机制预案，如发现数据泄漏风险，在24小时内完成迅速解决并通知受影响用户；
    </p>
    <p>
      （8）严格控制第三方服务的安全性内容。
    </p>

    <h2>五、您的个人信息权利</h2>
    <p>
      按照中国相关的法律法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
    </p>

    <p>1. 访问您的个人信息</p>
    <p>
      您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：
    </p>
    <p>
      账号信息——如果您希望访问或编辑您的账号中的个人资料信息和支付信息、更改您的密码、添加安全信息或绑定第三方账号等，您可以通过访问【我的】-【账号设置】-【修改密码】执行此类操作。
    </p>
    <p>
      如果您无法通过上述方式访问这些个人信息，您可以发送电子邮件至【dywlkj2023@163.com】。我们将在15个工作日内回复您的访问请求。
    </p>

    <p>2. 更正您的个人信息</p>
    <p>
      当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过“1.访问您的个人信息”中罗列的方式更正。
    </p>
    <p>
      如果您无法通过上述链接更正这些个人信息，您可以发送电子邮件至【dywlkj2023@163.com】。我们将在15个工作日内回复您的更正请求。
    </p>

    <p>3. 删除您的个人信息</p>
    <p>
      在以下情形中，您可以向我们提出删除个人信息的请求：
    </p>
    <ul>
      <li>（1）如果我们处理个人信息的行为违反法律法规；</li>
      <li>（2）如果我们收集、使用您的个人信息，却未征得您的同意；</li>
      <li>（3）如果我们处理个人信息的行为违反了与您的约定；</li>
      <li>（4）如果您注销了本软件账号；</li>
      <li>（5）如果我们终止服务及运营。</li>
    </ul>
    <p>
      您有权申请删除您的个人信息或注销账号，可通过发送电子邮件至【dywlkj2023@163.com】提交申请，我们将在15个工作日内完成核查与处理。若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
    </p>
    <p>
      当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
    </p>

    <p>4. 改变您授权同意的范围</p>
    <p>
      每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。
    </p>
    <p>
      您可以通过“1.访问您的个人信息”中罗列的方式自行操作。
    </p>
    <p>
      当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
    </p>

    <p>5. 您有权注销您的账号</p>
    <p>
      （1）您可以通过拨打本软件客服电话13366011888来申请注销您的账号，账号注销的处理期限为5个工作日。
    </p>
    <p>
      （2）当您注销账号后，您将无法再以该账号登录和使用我们的产品与服务；且该账号在本软件及相关服务使用期间已产生的但未消耗完毕的权益及未来的预期利益等全部权益将被清除；该账号下的内容、信息、数据、记录等将会被删除或匿名化处理（但法律法规另有规定或监管部门另有要求的除外，如依据《中华人民共和国网络安全法》规定，您的网络操作日志将至少保留六个月的时间）；本软件账号注销完成后，将无法恢复。
    </p>

    <p>6. 约束信息系统自动决策</p>
    <p>
      在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。
    </p>

    <p>7. 响应您的上述请求</p>
    <p>
      为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在15个工作日内作出答复。
    </p>
    <p>
      对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
    </p>
    <p>
      在以下情形中，按照法律法规要求，我们将无法响应您的请求：
    </p>
    <ul>
      <li>（1）与国家安全、国防安全有关的；</li>
      <li>（2）与公共安全、公共卫生、重大公共利益有关的；</li>
      <li>（3）与犯罪侦查、起诉和审判等有关的；</li>
      <li>（4）有充分证据表明您存在主观恶意或滥用权利的；</li>
      <li>
        （5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
      </li>
    </ul>

    <b>
      <h2>六、未成年人个人信息保护</h2>
      <p>
        以下条款请未成年用户（特别是未满十四周岁的儿童用户）在监护人的陪同下仔细阅读，并由监护人在充分理解后作出是否接受或拒绝本政策的决定：
      </p>
      <p>
        若用户是未满18周岁的未成年人（特别是未满十四周岁的儿童用户），应在监护人监护、指导并获得监护人同意情况下阅读本协议和使用本软件及相关服务。
      </p>

      <p>
        1.
        我们重视对未成年人个人信息保护，未成年用户在填写个人信息时，请加强个人保护意识并谨慎对待，请在监护人指导时正确使用本软件及相关服务。
      </p>
      <p>
        2.
        我们将根据国家相关法律法规及本政策的规定保护未成年人用户信息的保密性及安全性。如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。同时我们建立了严格的未成年人信息收集使用规则，以保护儿童和青少年个人信息安全。若您是未成年人的监护人，当您对您所监护的未成年人使用我们的服务或其向我们提供的用户信息有任何疑问时，请您根据本政策提供的联系方式及时与我们联系。
      </p>
    </b>

    <h2>七、隐私政策更新与通知</h2>
    <p>
      我们可能会适时对本隐私权政策进行调整或变更，当收集使用个人信息的目的、方式、范围发生变化时，我们将同步更新隐私政策，并通过弹窗提示、推送通知、APP内红点提醒等适当方式，主动提醒您重新阅读更新后的隐私政策内容。
    </p>
    <p>
      本隐私权政策的任何更新将以标注更新时间的方式公布在我们网站上，除法律法规或监管规定另有强制性规定外，经调整或变更的内容一经通知或公布后的7日后生效。如您在隐私权政策调整或变更后继续使用我们提供的任一服务或访问我们相关网站的，我们相信这代表您已充分阅读、理解并接受修改后的隐私权政策并受其约束。
    </p>

    <h2>八、权限申请与使用规则</h2>
    <p>
      我们仅会在您使用对应功能时，申请实现该功能所必需的个人信息权限，权限申请将与当前业务场景直接相关：
    </p>
    <p>
      当您使用“上传头像/图片”功能时，我们会申请“相册读取权限”或“相机拍摄权限”；
    </p>
    <p>
      每个权限将单独弹窗询问您的同意，您可以选择“允许”或“拒绝”，拒绝权限申请不会影响您使用App的其他功能；
    </p>
    <p>
      我们不会在App安装、启动时一次性申请多个与当前场景无关的权限。
    </p>

    <h2>九、争议解决与联系方式</h2>
    <p>
      1. 如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：
    </p>
    <ul>
      <li>邮箱：{{ contactEmail }}</li>
      <li>电话：{{ contactPhone }}</li>
      <li>地址：{{ address }}</li>
    </ul>
    <p>
      我们将在 15 个工作日内完成对您的投诉、举报或咨询的核查与处理，并向您反馈结果。
    </p>

    <p>
      2.
      争议解决：发生争议的，友好协商解决。协商不成的，应向广州市天河区有管辖权的人民法院提起诉讼。
    </p>

    <!-- <div class="actions">
      <button @click="agreePolicy">同意</button>
      <button @click="disagreePolicy">不同意</button>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      updateDate: "2025年04月15日",
      effectiveDate: "2025年04月15日",
      contactEmail: "dywlkj2023@163.com",
      contactPhone: "13366011888",
      address: "广东省广州市天河区林和西路9号1917房",
    };
  },
  methods: {
    agreePolicy() {
      console.log("用户已同意隐私协议");
      this.$emit("agree");
    },
    disagreePolicy() {
      console.log("用户不同意隐私协议");
      this.$emit("disagree");
    },
  },
};
</script>

<style scoped>
.privacy-policy {
  overflow-y: scroll;
  width: 100vw;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
}

h2 {
  margin-top: 30px;
  margin-bottom: 15px;
}

h3 {
  margin-top: 20px;
  margin-bottom: 10px;
}

ul {
  margin-left: 20px;
  margin-bottom: 15px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
}

.actions {
  margin-top: 30px;
  text-align: center;
}

button {
  padding: 10px 20px;
  margin: 0 10px;
  cursor: pointer;
}

button:first-child {
  background-color: #4caf50;
  color: white;
  border: none;
}

button:last-child {
  background-color: #f44336;
  color: white;
  border: none;
}
.update-date,
.effective-date {
  text-align: right;
}
</style>
